import { Row, Col } from "reactstrap"
import AvField from "availity-reactstrap-validation/lib/AvField"
import { useEffect, useState } from "react"
import General from "services/GeneralEndpoints"

const user = JSON.parse(localStorage.getItem("authUser"))
let generalService = new General(user)

const Location = props => {
  const [provinces, setprovinces] = useState()
  const [districts, setdistricts] = useState()
  const [sectors, setsectors] = useState()
  const [cells, setcells] = useState()

  useEffect(() => {
    fetchProvinces()
  }, [])

  const fetchProvinces = () => {
    generalService.getProvinces().then(response => {
      if (response.status) {
        const provs = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setprovinces(provs)
      }
    })
  }

  const fetchDistricts = province_id => {
    //setsectors([])
    generalService.getDistricts(province_id).then(response => {
      //console.log("districts ", response)
      if (response.status) {
        const dists = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setdistricts(dists)
      }
    })
  }

  const fetchSectors = district_id => {
    generalService.getSectors(district_id).then(response => {
      //console.log("sectors ", response)
      if (response.status) {
        const secs = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setsectors(secs)
      }
    })
  }

  const fetchCells = sector_id => {
    generalService.getCells(sector_id).then(response => {
      console.log("cells ", response)
      if (response.status) {
        const cells = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setcells(cells)
      }
    })
  }

  const onChangeProvince = value => {
    setsectors([])
    setcells([])
    if (value != "") {
      fetchDistricts(value)
    }
  }

  const onChangeDistrict = value => {
    setcells([])
    if (value != "") {
      fetchSectors(value)
    }
  }

  const onChangeSector = value => {
    if (value != "") {
      fetchCells(value)
    }
  }
  return (
    <Row>
      <Col md="4">
        <div className="mb-3">
          <AvField
            name="province_id"
            label="Select Province"
            type="select"
            onChange={e => onChangeProvince(e.target.value)}
            required
          >
            <option value={""}>--Select--</option>
            {provinces}
          </AvField>
        </div>
      </Col>
      <Col md="4">
        <div className="mb-3">
          <AvField
            name="district_id"
            label="Select District"
            type="select"
            onChange={e => onChangeDistrict(e.target.value)}
            required
          >
            <option value={""}>--Select--</option>
            {districts}
          </AvField>
        </div>
      </Col>

      <Col md="4">
        <div className="mb-3">
          <AvField
            name="sector_id"
            label="Select Sector"
            type="select"
            required
            onChange={e => onChangeSector(e.target.value)}
          >
            <option value="">--Select--</option>
            {sectors}
          </AvField>
        </div>
      </Col>

      <Col md="4">
        <div className="mb-3">
          <AvField
            name="cell_id"
            label="Select Cell"
            type="select"
            required
            
          >
            <option value="">--Select--</option>
            {cells}
          </AvField>
        </div>
      </Col>
    </Row>
  )
}

export default Location
